import { render, staticRenderFns } from "./kol.vue?vue&type=template&id=1cb382e1&scoped=true"
import script from "./kol.vue?vue&type=script&lang=js"
export * from "./kol.vue?vue&type=script&lang=js"
import style0 from "./kol.vue?vue&type=style&index=0&id=1cb382e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb382e1",
  null
  
)

export default component.exports